import { actionTypes } from '../actions/types';

type AppActions = import('../actions/types').AppActions;

// TODO: Change this to generated types, types are not correct from back-end.
interface Consent {
    samtykkeId: {
        value: string;
    };
    tittel: string;
    // Texts are resolved locally (indexed on `samtykkeId.value`); the back-end
    // currently returns an empty array here.
    tekster: string[];
    // Kept optional for backwards compatibility with any lingering back-end fields.
    infoTekst?: string;
    svarNeiTekst?: string;
}

export interface ConsentData extends Consent {
    svar: string;
}
export interface ConsentReducer {
    data: ConsentData[];
}

export const initialState: ConsentReducer = {
    data: [],
};

export const consentReducer = (state = initialState, action: AppActions = {} as AppActions): ConsentReducer => {
    switch (action.type) {
        case actionTypes.FETCH_CONSENT_FULFILLED: {
            return {
                ...state,

                data: action.payload.map((c: any) => {
                    if (state.data) {
                        state.data.forEach((storedConsent) => {
                            if (storedConsent.samtykkeId.value === c.samtykkeId.value) {
                                c.svar = storedConsent.svar;
                            }
                        });
                    }
                    return c;
                }),
            };
        }
        case actionTypes.FETCH_CONSENT_FAILED: {
            return {
                ...state,
                data: [],
            };
        }

        case actionTypes.UPDATE_CONSENT: {
            const { name, value } = action.payload;
            return {
                ...state,
                data: state.data.map((c) => {
                    const id = c.samtykkeId.value;

                    if (id === name) {
                        return {
                            ...c,
                            svar: value,
                        };
                    }

                    return c;
                }),
            };
        }

        default:
            return state;
    }
};
